<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <!-- Header & Navigation -->
    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ 'Wallet Management' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'Wallet Management' | transloco }}</h2>
      </div>

      <div class="bb-header-actions">
        <button routerLink="/promocode" class="bb-btn bb-btn-primary">
          {{ "Promo Code" | transloco }}
        </button>

        <button routerLink="/notifications" class="bb-btn bb-btn-secondary">
          {{ "Notifications" | transloco }}
        </button>
      </div>
    </header>

    <!-- Users Table -->
    <div class="bb-table-card bb-p-16">
      <div class="bb-table-scroll">
        <table class="table table-custom">
          <thead>
            <tr>
              <th>{{ "Name" | transloco }}</th>
              <th>{{ "username" | transloco }}</th>
              <th>{{ "phone" | transloco }}</th>
              <th>{{ "amount" | transloco }}</th>
              <th class="bb-actions-th">{{ "add balance" | transloco }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let element of dataSource.data">
              <td>{{ element.name }}</td>
              <td>{{ element.username }}</td>
              <td>{{ element.phone }}</td>

              <td>
                <strong class="bb-price bb-text-blue">
                  {{ element.balance }} {{ "egp" | transloco }}
                </strong>
              </td>

              <td class="bb-actions-td">
                <button
                  type="button"
                  class="bb-icon-btn"
                  (click)="addCredit(element.id)"
                  title="{{ 'add balance' | transloco }}"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M3 7a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v3H3V7z" />
                    <path d="M3 10h18v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7z" />
                    <line x1="12" y1="13" x2="12" y2="17" />
                    <line x1="10" y1="15" x2="14" y2="15" />
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- No Data State -->
      <div *ngIf="noData" class="bb-empty-state bb-text-center">
        <app-nodata></app-nodata>
      </div>
    </div>

  </div>
</section>

<!-- Add Balance Popup Modal -->
<div *ngIf="addBalancePopUp" class="bb-modal-backdrop popup" (click)="close()">
  <div class="bb-modal-card bb-modal-sm popup-box" (click)="$event.stopPropagation()">

    <div class="bb-modal-header">
      <h4>{{ "add balance" | transloco }}</h4>

      <button type="button" class="bb-modal-close" (click)="close()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="bb-grid bb-gap-16">

      <div class="bb-text-center">
        <span class="bb-upload-icon">
          <img src="/assets/income.png" [alt]="'income' | transloco" />
        </span>
      </div>

      <div class="bb-field">
        <label class="bb-label" for="amount">{{ 'amount' | transloco }}</label>
        <input
          class="bb-input"
          id="amount"
          type="number"
          min="0"
          [(ngModel)]="amount"
          [ngModelOptions]="{standalone: true}"
          placeholder="{{ 'Enter amount' | transloco }}"
        />
      </div>

      <div class="bb-field">
        <label class="bb-label" for="note">{{ 'note' | transloco }}</label>
        <input
          class="bb-input"
          id="note"
          type="text"
          [(ngModel)]="note"
          [ngModelOptions]="{standalone: true}"
          placeholder="{{ 'Add a note' | transloco }}"
        />
      </div>

    </div>

    <div class="bb-modal-actions">
      <button
        type="button"
        class="bb-btn bb-btn-primary"
        (click)="onSubmit()"
        [disabled]="!amount || amount <= 0"
      >
        {{ "Submit" | transloco }}
      </button>

      <button type="button" class="bb-btn bb-btn-secondary" (click)="close()">
        {{ "close" | transloco }}
      </button>
    </div>

  </div>
</div>